import { render, staticRenderFns } from "./NewSubCat.vue?vue&type=template&id=30b9bd81&scoped=true"
import script from "./NewSubCat.vue?vue&type=script&lang=js"
export * from "./NewSubCat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b9bd81",
  null
  
)

export default component.exports